import { Component, OnInit, EventEmitter, ViewChild, Output, OnChanges, Input, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component';
import { Subscription } from 'rxjs';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageEvaluationFilterService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluationfilter.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { PhBhpPdfComplianceMultiFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance-multi-filter/ph-bhp-pdf-compliance-multi-filter.component';
import { PhBhpBarChartComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import { PhBhpPdfComplianceMultiFilterObserveComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance-multi-filter-observe/ph-bhp-pdf-compliance-multi-filter-observe.component';
import cloneDeep from 'lodash/cloneDeep';
import { PhBhpObserveChartExportComponent } from '../ph-bhp-observe-chart-export/ph-bhp-observe-chart-export.component';
@Component({
  selector: 'app-ph-bhp-observe-comments',
  templateUrl: './ph-bhp-observe-comments.component.html',
  styleUrls: ['./ph-bhp-observe-comments.component.css']
})
export class PhBhpObserveCommentsComponent implements OnInit, OnDestroy {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  private static readonly INITIAL_FIELDS = [
    { 'field': 'title', 'title': 'EVALUATION.TITLE' }
  ];
  pageTitle: string;
  textLegend: string;
  langSubscription: Subscription;
  institutionSubscription: Subscription;
  tempFilter;
  showCompareCard;
  data;
  filterDetails = [];
  isDesktop = true;
  isAdjustableHeight = true;
  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceMultiFilterObserveComponent;
  @ViewChild('exportTag', { static: true }) exportTag: PhBhpObserveChartExportComponent;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;
  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;
  isSavedFromEvaluation: boolean;
  noDataFound: boolean = false;
  sopiDs: Array<any> = [];
  percentageLegend = "{0}%";
  complianceType;
  pageInfo = {
    ofLabel: 'GENERAL.OF',
    items: 'GENERAL.ITEMS',
    itemsPerPageLabel: 'GENERAL.ITEMS_PAGE'
  };

  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;

  isCallFor;
  userSubscription: Subscription;
  userID;
  roleId;
  appName = '';
  filterIndices: number[] = [0];
  evaluationLoaded: boolean = false;
  selectedCommentID: string = "";
  selectedCommentName: string = "";
  quickComments: Array<any>;
  commentTranslations;
  isBenchmark: boolean = false;
  isEvaluationTable: boolean = true;
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;
  
  filterName: string[] = [];

  multiSelectText: string = '';
  results: any = [];
  userFilters: any;
  sopFilters: any[] = [];
  constructor(
    public appConfig: AppConfig,
    private router: Router,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    private filterService: PHBHPFeaturePackageEvaluationFilterService) {
    this.textLegend = this.layoutService.translateText("EVALUATION.COMMENTS");
  }

  ngOnInit(): void {
    // Asegurar que todos los filtros tengan filterName antes de usarlos
    if (this.userFilters && this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
    }
    this.userID = this.appConfig.userData.userId;
    this.roleId = this.appConfig.userData.roleName.roleId;
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      setTimeout(() => {
        for (let i = 0; i < this.charts.length; i++) {
          let chart = this.charts.get(i);
          chart.chartOptions.valueAxis.title.text = this.textLegend;
        }

        this.pageTitle = this.layoutService.translateText(this.translationKeys.SOPObservation.Comments);
        this.compliance.complianceTitle = this.layoutService.translateText(this.translationKeys.SOPObservation.Comments);

        //Generate again labels for charts and tables
        this.evaluate(true);

        this.layoutService.showLoader = false;
      }, 1000);
    });

    this.pageTitle = this.layoutService.translateText(this.translationKeys.SOPObservation.Comments);
    this.compliance.complianceTitle = this.layoutService.translateText(this.translationKeys.SOPObservation.Comments);
    this.ngOnChanges();
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;
    this.userHasFilter = false;
    if (!this.isUserFilterSetted) {
      this.evaluationService.getUserHasObserveEvaluationFilter(this.appConfig.userData.userId, 'observeComments').subscribe((userHasFilter) => {
        this.isUserFilterSetted = true;
        if (userHasFilter) {
          this.userHasFilter = true;
          this.userFilters = JSON.parse(userHasFilter.filterList);
          this.userFilters = this.userFilters.Filter;
          setTimeout(() => { this.initComponent(); }, 500);
        } else {
          this.userFilters = [];
          this.noDataFound = true;
          this.filters.get(0).showFilter(true);
          this.compliance.resultsLoader.next([{}]);
          this.getPredefinedComments();
        }
      }, (error) => { }, () => { this.layoutService.showLoader = false; });
    } else {
      setTimeout(() => { this.initComponent(); },500);
    }
  }

  ngOnDestroy() {
    if (this.langSubscription)
      this.langSubscription.unsubscribe();
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
    if (this.institutionSubscription)
      this.institutionSubscription.unsubscribe();
  }

  initComponent() {
    if (this.userFilters.length > 0) {
      this.filterIndices = this.userFilters.map((_, index) => index);
      this.showCompareCard = this.filterIndices.length > 1;
      
      // Initialize filterName array with default values
      this.filterName = this.userFilters.map((filter, index) =>
        filter.filterName && filter.filterName.trim() !== ""
          ? filter.filterName
          : this.layoutService.translateText('EVALUATION.FILTER') + ` ${index + 1}`
      );
    }

    this.getPredefinedComments();

    if (this.appConfig.userData) {
      for (let i = 0; i < this.charts.length; i++) {
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.labels = {
          format: this.percentageLegend
        };
        chart.chartOptions.valueAxis.title = {
          text: this.layoutService.translateText(this.translationKeys.SOPObservation.Comments),
          font: "9px OpenSans-Regular"
        };
      }

      this.compliance.showFilter = true;
      this.compliance.complianceTitle = this.pageTitle;
      this.compliance.roleId = this.roleId;
      this.compliance.fillWith = 'N/A';
      this.loadFiltersInfo();
      if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.tempFilter = this.userFilters;
      }

      this.evaluate(true, true);
    }
  }

  evaluate(getResults, initialize?) {
    this.printConfig();
    this.data = {
      commentsIDs: this.selectedCommentID,
      filter: [],
      isBenchmark: true,
      roleId: this.roleId,
      countryID: this.appConfig.userData.country,
      institutions: this.appConfig.institutions || 0
    };

    if (this.selectedCommentID == "") {
      if (this.quickComments) {
        this.quickComments.forEach((comment) => {
          this.data.commentsIDs += comment.predefinedCommentID + ","
        })
        this.data.commentsIDs = this.data.commentsIDs.slice(0, -1);
      }
    }

    if (initialize) {
      // Create a copy of userFilters and add filterName to each filter
      this.data.filter = this.userFilters.map((filter, index) => ({
        ...filter,
        filterName: this.filterName && this.filterName[index] 
          ? this.filterName[index] 
          : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)
      }));
    } else {
      this.filters.forEach((filter, index) => {
        let filterData: any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          instutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: 0,
          filterName: this.filterName && this.filterName[index] 
            ? this.filterName[index] 
            : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)
        };

        if (this.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filter.push(filterData);
        if (filterData.multiSelectName) {
          this.multiSelectText = filterData.multiSelectName;
        }
      });
    }

    this.userHasFilter = true;
    if (getResults == true) {
      this.getObserveCommentsDetails(this.userID, this.data);
    } else if (getResults == false) {
      this.saveObserveCommentsDetails(this.userID, this.data)
    }
  }

  async loadFiltersInfo() {
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }, 750);
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  emitData(valve) {
    if (valve.value) {
      this.appConfig.filterDetails = valve.value;
      this.appConfig.dropdownChanged = "changed";
    } else {
      this.appConfig.filterDetails = [];
    }
    switch (valve.key) {
      case 'back': this.router.navigate(['evaluation/observeObservation/statistical']); break; // this._location.back();
      case 'overallCompliance': this.router.navigate(['evaluation/observe/overallCompliance']); break;
      case '5Moments': this.router.navigate(['evaluation/observe/fivemoments']); break;
      case 'individualData': this.router.navigate(['evaluation/observe/individualOverview']); break;
      case 'beforeAsepticProcedures': this.router.navigate(['evaluation/observe/StatisticsBeforeAsepticProcedures']); break;
      case 'comments': this.router.navigate(['evaluation/observe/comments']); break;
      case 'quota': this.router.navigate(['evaluation/observe/quota']); break;
      default: this.router.navigate(['evaluation/observeObservation/statistical']); break;
    }
  }

  filterCompare() {
    if (this.filterIndices.length < 6) {
      this.filterIndices.push(this.filterIndices.length);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    this.layoutService.showLoader = true;
    setTimeout(() => {
      var filters = this.filters.toArray();
      filters[filters.length - 1].setInfoFromFilter(cloneDeep(filters[filters.length - 2]));
      this.layoutService.showLoader = false;
    }, 500);

    if (!this.userHasFilter) {
      this.filters.get(0).showFilter(true);
      return;
    }
  }

  printConfig() {
    if (this.sopiDs.length == 0) {
      this.compliance.SOPList = this.sopiDs;
      this.compliance.SOPName = undefined;
    } else {
      this.compliance.SOPList = undefined;
      this.compliance.SOPName = this.layoutService.translateText("EVALUATION.All.SOP");
    }
  }

  saveObserveCommentsDetails(userID, data) {
    this.isCallFor = "ObserveComments";
    this.complianceType = "observeComments";
    this.isSavedFromEvaluation = false;
    this.layoutService.showLoader = true;
    this.evaluationService.SaveSummarisedDetail(userID, this.isSavedFromEvaluation, this.complianceType, data).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.layoutService.showSuccess(this.layoutService.translateText("EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT"));
    })
  }

  getObserveCommentsDetails(userID, data) {
    this.complianceType = "observeComments";
    this.isCallFor = "observeComments";
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.evaluationService.getCommentsOverviewMulti(userID, this.complianceType, this.isCallFor, this.isSavedFromEvaluation, data).subscribe((res: any) => {
      this.buildChart(res);
    })
  }

  createFilterData(userID: number) {
    const defaultFilterData = {
      startDate: new Date(),
      endDate: new Date(),
      instutionIDs: "",
      departmentID: "",
      wardID: "",
      professionalCategoryID: "",
      subprofessionalCategoryID: "",
      countryID: 0
    };

    const filters = this.filters && this.filters.length > 0 ? this.filters.map(filter => {
      let filterData = { ...defaultFilterData, startDate: filter.range.start, endDate: filter.range.end };
      if (this.roleId === 1 && filter.setCountry !== 0) {
        filterData.countryID = filter.setCountry.countryID;
      }
      return filter.assignData(filterData);
    }) : [defaultFilterData];

    return {
      filter: filters,
      countryID: 0,
      isBenchmark: true,
      userId: userID,
      isSavedFromEvaluation: true,
      commentIDs: this.selectedCommentID,
      roleId: this.roleId
    };
  }

  setFilterDetails() {
    if (this.filterDetails.length > 0) {
      if (this.filters) {
        this.filterService.setFiltersValue(this.filterDetails, this.filters.toArray());
      }
    }
  }

  onCommentChange(comment, evaluate: boolean = true) {
    if (comment != 0) {
      this.selectedCommentID = comment.predefinedCommentID;
      this.selectedCommentName = comment.commentName;
    } else {
      this.selectedCommentID = "";
      this.selectedCommentName = this.layoutService.translateText('EVALUATION.All.COMMENTS');
    }

    if(evaluate){
      this.evaluate(true);
    }
  }

  ngAfterViewChecked() {
    if (this.tempFilter) {
      var tempFilter = this.tempFilter;
      this.tempFilter = undefined;

      this.filters.toArray().forEach((filterComponent, index) => {
        if (tempFilter.filter[index]) {
          let startDate = new Date(tempFilter.filter[index].startDate);
          startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
          let endDate = new Date(tempFilter.filter[index].endDate);
          endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
          filterComponent.dateRange = [startDate, endDate];
          filterComponent.selectDate();
          filterComponent.setCountryFilter(tempFilter.filter[index].countryID, tempFilter.filter[index].instutionIDs, tempFilter.filter[index].wardID, true);
          filterComponent.setDepartmentFilter(tempFilter.filter[index].departmentID, true);
          filterComponent.setProfessionalCategory(tempFilter.filter[index].professionalCategoryID, tempFilter.filter[index].subprofessionalCategoryID, true);
        }
      });

      setTimeout(() => {
        this.compliance.setFilters(this.filters.toArray());
      }, 1000);
    }
  }

  buildChart(res) {
    this.evaluationLoaded = false;
    var colors = [];
    if (!this.shouldHideBenchmarkDataByResponse(res) || this.shouldHideBenchmarkData()) {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    } else {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    }

    res = this.adjustResponseForEnvironment(res);
    res = this.filterBenchmarkDataIfWardIsSelected(res);

    let chart: PhBhpBarChartComponent;
    this.results = [];
    res.forEach(result => {
      if (result.observeCommentsList.length > 0) {
        let id = result.filterType || 'single';
        if (this.results.findIndex(r => r.id === id) === -1) {
          this.results.push({
            id,
            observeCommentsList: [],
            gridData: [],
            fields: [...PhBhpObserveCommentsComponent.INITIAL_FIELDS],
            benchmarkFields: [...PhBhpObserveCommentsComponent.INITIAL_FIELDS],
            noDataFound: true
          });
        }
      }
    });

    this.compliance.resultsLoader.next(Object.assign([], this.results));
    // The timeout is necessary to give the chart QueryList time to load the component
    setTimeout(() => {
      let filterCount: number = 0;
      let benchmarkCount: number = 0;
      let filterTableCount: number = 0;
      let benchmarkTableCount: number = 0;
      res.forEach((observeCommentsArray: any, index) => {
        let chartId = observeCommentsArray.filterType || 'single';
        observeCommentsArray.filterType = chartId;
        let chartIndex = this.results.findIndex(r => r.id === chartId);
        chart = this.charts.get(chartIndex);
        let data = JSON.parse(JSON.stringify(chart.chartOptions));

        // Initialize only first iteration of the chart
        if (!data.setId) {
          data.nextIndex = 0;
          data.categoryAxis.categories = [];
          data.categoryAxis.categoryOffset = [];
          data.series = [];
          data.seriesIdentifier = [];
        }

        data.series[data.nextIndex] = { data: [], name: [], dataOffset: [], serieIndex: index };
        data.series[data.nextIndex].color = colors[index];
        data.seriesIdentifier[data.nextIndex] = [];
        chart.chartId = chartId;

        if (observeCommentsArray.isBenchmark === false) {
          if (observeCommentsArray.observeCommentsList.length === 1 && observeCommentsArray.observeCommentsList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        } else {
          if (observeCommentsArray.observeCommentsList.length === 2 && observeCommentsArray.observeCommentsList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        }

        observeCommentsArray.observeCommentsList.forEach((observeComments) => {
          let observeCommentsItem = observeComments;
          data.series[data.nextIndex].dataSetId = observeCommentsItem.id;
          observeCommentsItem.list.forEach((item) => {
            
            const comment = this.quickComments.find(c => c.predefinedCommentID === item.predefinedCommentID);
            if(!comment) return;
            const categoryTitle = comment.commentName;
            const categoryTitleKey = this.layoutService.getTranslationKey(categoryTitle);
            const selectedTitle = this.selectedCommentName;
            const selectedTitleKey = this.layoutService.getTranslationKey(selectedTitle);
            
            let title = this.layoutService.translateText(categoryTitle);
            if (observeCommentsItem.id >= 0 && observeCommentsItem.name) {
              title += " - " + this.layoutService.translateText(observeCommentsItem.name);
            }
            data.series[data.nextIndex].data.push(item.commentsPercentage >= 0 ? item.commentsPercentage : "NODATA");
            data.series[data.nextIndex].dataOffset.push({ id: title, setId: observeCommentsItem.id, value: item.commentsPercentage });
            data.seriesIdentifier[data.nextIndex].push({ id: title, setId: observeCommentsItem.id });
            if (!data.categoryAxis.categories.includes(title)) {
              data.categoryAxis.categories.push(title);
              data.categoryAxis.categoryOffset.push({ id: title, setId: observeComments.id });
            }
          });
        });

        let maxLength = data.categoryAxis.categoryOffset.length
        const combinedData = data.series.map(() => new Array(maxLength).fill(null));

        data.series.forEach((item, serieIndex) => {
          item.dataOffset.forEach((value, index) => {
            let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
            combinedData[serieIndex][indexOffset] = value.value;
          });
        });

        for (let i = 0; i < combinedData.length; i++) {
          data.series[i].data = combinedData[i];
        }


        if (observeCommentsArray.isBenchmark) {
          if (this.shouldHideBenchmarkData()) {
            return;
          }
          benchmarkCount++;
          const benchmarkName = `${this.data.filter && this.data.filter[benchmarkCount-1] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkCount-1].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkCount)}`
          data.series[data.nextIndex].name = [benchmarkName];
          data.series[data.nextIndex].filterName = [benchmarkName];
          data.series[data.nextIndex].filterNum = benchmarkCount;
        } else {
          filterCount++;
          data.series[data.nextIndex].name = [`${this.data.filter && this.data.filter[filterCount - 1] ? this.data.filter[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
          data.series[data.nextIndex].filterName = [`${this.data.filter && this.data.filter[filterCount - 1] ? this.data.filter[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
          data.series[data.nextIndex].filterNum = filterCount
        }

        data.categoryAxis.rotation = 0;
        data.categoryAxis.maxDivisions = 12;
        data.setId = chartId;
        data.nextIndex++;
        chart.chartOptions = data;
        chart.chartDatamani();

        let gridData: any[] = this.results[chartIndex].gridData;
        let fields = this.results[chartIndex].fields;
        let benchmarkFields = this.results[chartIndex].benchmarkFields;
        gridData = Object.assign([], gridData);
        if (observeCommentsArray && !observeCommentsArray.isBenchmark) {
          observeCommentsArray.observeCommentsList.forEach((element) => {
            let res2 = element.list;
            let multiName = '';
            let elementId = '';
            if (observeCommentsArray.filterType && observeCommentsArray.filterType != 'single') {
              multiName = element.name;
              elementId = element.id;
              if (element.list.length == 0 && element.noData == true) {
                multiName = 'EVALUATION.NO_DATA'
                elementId = 'nodata';
              }

              var columnFilterTouched = `column_filter_touched_${filterTableCount + 1}_${elementId}`;
              var columnFilterTotal = `column_filter_total_${filterTableCount + 1}_${elementId}`;
              var columnFilterCompliance = `column_filter_compliance_${filterTableCount + 1}_${elementId}`;
              const filterGroupName = `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`;
              if (fields.findIndex(f => f.field === columnFilterTouched) === -1) {
                fields.push(
                  { 'field': columnFilterTouched, 'title': 'EVALUATION.TOTAL.NUMBER_TOUCHED_COMMENTS', 'group': filterGroupName, multiName: multiName },
                );
              }

              if (fields.findIndex(f => f.field === columnFilterTotal) === -1) {
                fields.push(
                  { 'field': columnFilterTotal, 'title': 'DASHBOARD.TOTAL_AMOUNT', 'group': filterGroupName, multiName: multiName },
                );
              }

              if (fields.findIndex(f => f.field === columnFilterCompliance) === -1) {
                fields.push(
                  { 'field': columnFilterCompliance, 'title': 'EVALUATION.TOUCHED_COMMENTS_PERCENT', 'group': filterGroupName, multiName: multiName },
                );
              }

              res2.forEach((item, i) => {
                const comment = this.quickComments.find(c => c.predefinedCommentID === item.predefinedCommentID);
                if(!comment) return;
                const categoryTitle = comment.commentName;
                const categoryTitleKey = this.layoutService.getTranslationKey(categoryTitle);
                const selectedTitle = this.selectedCommentName;
                const selectedTitleKey = this.layoutService.getTranslationKey(selectedTitle);
                var gridItem = gridData.find((gridItem) => gridItem.name === comment.commentName);
                if (!gridItem) {
                  gridItem = { name: comment.commentName, title: comment.commentName };
                  gridData.push(gridItem);
                }

                var gridItemIndex = gridData.findIndex((gridItem) => gridItem.name === comment.commentName);
                gridData[gridItemIndex][`column_filter_touched_${filterTableCount + 1}_${elementId}`] = item.touchedComments;
                gridData[gridItemIndex][`column_filter_total_${filterTableCount + 1}_${elementId}`] = item.totalObservations;
                gridData[gridItemIndex][`column_filter_compliance_${filterTableCount + 1}_${elementId}`] = item.commentsPercentage == -1 ? "N/A" : item.commentsPercentage;
              });
            } else {

              var columnFilterTouched = `column_filter_touched_${filterTableCount + 1}`;
              var columnFilterTotal = `column_filter_total_${filterTableCount + 1}`;
              var columnFilterCompliance = `column_filter_compliance_${filterTableCount + 1}`;
              const filterGroupName = `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`;
              if (fields.findIndex(f => f.field === columnFilterTouched) === -1) {
                fields.push(
                  { 'field': columnFilterTouched, 'title': 'EVALUATION.TOTAL.NUMBER_TOUCHED_COMMENTS', 'group': filterGroupName },
                );
              }

              if (fields.findIndex(f => f.field === columnFilterTotal) === -1) {
                fields.push(
                  { 'field': columnFilterTotal, 'title': 'DASHBOARD.TOTAL_AMOUNT', 'group': filterGroupName },
                );
              }

              if (fields.findIndex(f => f.field === columnFilterCompliance) === -1) {
                fields.push(
                  { 'field': columnFilterCompliance, 'title': 'EVALUATION.TOUCHED_COMMENTS_PERCENT', 'group': filterGroupName },
                );
              }

              res2.forEach((item, i) => {
                const comment = this.quickComments.find(c => c.predefinedCommentID === item.predefinedCommentID);
                if(!comment) return;
                const categoryTitle = comment.commentName;
                const categoryTitleKey = this.layoutService.getTranslationKey(categoryTitle);
                const selectedTitle = this.selectedCommentName;
                const selectedTitleKey = this.layoutService.getTranslationKey(selectedTitle);

                var gridItem = gridData.find((gridItem) => gridItem.name === categoryTitle);
                if (!gridItem) {
                  gridItem = { name: categoryTitle, title: categoryTitle};
                  gridData.push(gridItem);
                }

                var gridItemIndex = gridData.findIndex((gridItem) => gridItem.name === categoryTitle);
                gridData[gridItemIndex][`column_filter_touched_${filterTableCount + 1}`] = item.touchedComments;
                gridData[gridItemIndex][`column_filter_total_${filterTableCount + 1}`] = item.totalObservations;
                gridData[gridItemIndex][`column_filter_compliance_${filterTableCount + 1}`] = item.commentsPercentage == -1 ? "N/A" : item.commentsPercentage;
              });
            }

          });
        } else {
          observeCommentsArray.observeCommentsList.forEach((element) => {
            let res2 = element.list;
            let multiName = '';
            let elementId = '';
            if (observeCommentsArray.filterType && observeCommentsArray.filterType != 'single') {
              multiName = element.name;
              elementId = element.id;
              if (element.list.length == 0 && element.noData == true) {
                multiName = 'EVALUATION.NO_DATA'
                elementId = 'nodata';
              }

              var columnBenchmarkFilterTouched = `column_benchmark_touched_${benchmarkTableCount + 1}_${elementId}`;
              var columnBenchmarkFilterTotal = `column_benchmark_total_${benchmarkTableCount + 1}_${elementId}`;
              var columnBenchmarkFilterCompliance = `column_benchmark_compliance_${benchmarkTableCount + 1}_${elementId}`;
              const benchmarkGroupName = `${this.data.filter && this.data.filter[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}`;
              if (benchmarkFields.findIndex(f => f.field === columnBenchmarkFilterTouched) === -1) {
                benchmarkFields.push(
                  { 'field': columnBenchmarkFilterTouched, 'title': 'EVALUATION.TOTAL.NUMBER_TOUCHED_COMMENTS', 'group': benchmarkGroupName, multiName: multiName },
                );
              }

              if (benchmarkFields.findIndex(f => f.field === columnBenchmarkFilterTotal) === -1) {
                benchmarkFields.push(
                  { 'field': columnBenchmarkFilterTotal, 'title': 'DASHBOARD.TOTAL_AMOUNT', 'group': benchmarkGroupName, multiName: multiName },
                );
              }

              if (benchmarkFields.findIndex(f => f.field === columnBenchmarkFilterCompliance) === -1) {
                benchmarkFields.push(
                  { 'field': columnBenchmarkFilterCompliance, 'title': 'EVALUATION.TOUCHED_COMMENTS_PERCENT', 'group': benchmarkGroupName, multiName: multiName },
                );
              }

              res2.forEach((item, i) => {
                const comment = this.quickComments.find(c => c.predefinedCommentID === item.predefinedCommentID);
                if(!comment) return;
                const categoryTitle = comment.commentName;
                const categoryTitleKey = this.layoutService.getTranslationKey(categoryTitle);
                const selectedTitle = this.selectedCommentName;
                const selectedTitleKey = this.layoutService.getTranslationKey(selectedTitle);

                var gridItem = gridData.find((gridItem) => gridItem.name === categoryTitle);
                if (!gridItem) {
                  gridItem = { name: categoryTitle, title: categoryTitle };
                  gridData.push(gridItem);
                }

                var gridItemIndex = gridData.findIndex((gridItem) => gridItem.name === categoryTitle);
                gridData[gridItemIndex][`column_benchmark_touched_${benchmarkTableCount + 1}_${elementId}`] = item.touchedComments;
                gridData[gridItemIndex][`column_benchmark_total_${benchmarkTableCount + 1}_${elementId}`] = item.totalObservations;
                gridData[gridItemIndex][`column_benchmark_compliance_${benchmarkTableCount + 1}_${elementId}`] = item.commentsPercentage == -1 ? "N/A" : item.commentsPercentage;
              });
            } else {
              var columnBenchmarkFilterTouched = `column_benchmark_touched_${benchmarkTableCount + 1}`;
              var columnBenchmarkFilterTotal = `column_benchmark_total_${benchmarkTableCount + 1}`;
              var columnBenchmarkFilterCompliance = `column_benchmark_compliance_${benchmarkTableCount + 1}`;
              const benchmarkGroupName = `${this.data.filter && this.data.filter[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}`;
              if (benchmarkFields.findIndex(f => f.field === columnBenchmarkFilterTouched) === -1) {
                benchmarkFields.push(
                  { 'field': columnBenchmarkFilterTouched, 'title': 'EVALUATION.TOTAL.NUMBER_TOUCHED_COMMENTS', 'group': benchmarkGroupName },
                );
              }

              if (benchmarkFields.findIndex(f => f.field === columnBenchmarkFilterTotal) === -1) {
                benchmarkFields.push(
                  { 'field': columnBenchmarkFilterTotal, 'title': 'DASHBOARD.TOTAL_AMOUNT', 'group': benchmarkGroupName },
                );
              }

              if (benchmarkFields.findIndex(f => f.field === columnBenchmarkFilterCompliance) === -1) {
                benchmarkFields.push(
                  { 'field': columnBenchmarkFilterCompliance, 'title': 'EVALUATION.TOUCHED_COMMENTS_PERCENT', 'group': benchmarkGroupName },
                );
              }

              res2.forEach((item, i) => {
                const comment = this.quickComments.find(c => c.predefinedCommentID === item.predefinedCommentID);
                if(!comment) return;
                const categoryTitle = comment.commentName;
                const categoryTitleKey = this.layoutService.getTranslationKey(categoryTitle);
                const selectedTitle = this.selectedCommentName;
                const selectedTitleKey = this.layoutService.getTranslationKey(selectedTitle);

                var gridItem = gridData.find((gridItem) => gridItem.name === categoryTitle);
                if (!gridItem) {
                  gridItem = { name: categoryTitle, title:categoryTitle};
                  gridData.push(gridItem);
                }

                var gridItemIndex = gridData.findIndex((gridItem) => gridItem.name === categoryTitle);
                gridData[gridItemIndex][`column_benchmark_touched_${benchmarkTableCount + 1}`] = item.touchedComments;
                gridData[gridItemIndex][`column_benchmark_total_${benchmarkTableCount + 1}`] = item.totalObservations;
                gridData[gridItemIndex][`column_benchmark_compliance_${benchmarkTableCount + 1}`] = item.commentsPercentage == -1 ? "N/A" : item.commentsPercentage;
              });
            }

          });
        }

        if (observeCommentsArray.isBenchmark) {
          benchmarkTableCount += 1;
        } else {
          filterTableCount += 1;
        }

        this.results[chartIndex].gridData = gridData;
        this.results[chartIndex].fields = fields;
        this.results[chartIndex].benchmarkFields = benchmarkFields;
        this.results[chartIndex].resultChart = chart;


        setTimeout(() => {
          let complianceChart = this.compliance.charts.get(chartIndex);
          if (complianceChart) {
            complianceChart.chartDatamani();
          }
          this.compliance.setComplianceFields(this.results[chartIndex], 6, 2);
          this.compliance.setFilters(this.filters.toArray());

          if (index == res.length - 1) {
            this.compliance.resultsLoader.next(cloneDeep(this.results));
            if (this.exportTag) {
              this.exportTag.results = Object.assign([], this.results);
            }
          }

        }, 500);
      });

      this.changeLangProcessPage();
      this.evaluationLoaded = true;
      setTimeout(() => { this.initializeFilters(); }, 1000);

    }, 1000);
    
  }

  changeLangProcessPage() {
    this.results.forEach((result, gridIndex) => {
      result.gridData.forEach((value, index) => {
        if (value.title)
          this.results[gridIndex].gridData[index].title = this.layoutService.translateText(value.title);
        this.compliance.results[gridIndex].gridData[index].title = this.layoutService.translateText(value.title);
      });
    });
  }

  shouldHideBenchmarkDataByResponse(complianceList) {
    // If there is any response isBenchmark: true, then we should show benchmark data
    return complianceList.some(item => item.isBenchmark);
  }

  checkHasBenchmarkData(observationPredefinedCommentsResultList) {
    var isBenchmarkMapped = observationPredefinedCommentsResultList.map(item => item.isBenchmark);
    return isBenchmarkMapped.includes(true);
  }

  initializeFilters() {
    this.selectedSeries = [];
    this.filters.forEach((filter, index) => {
      filter.visible = true;
    });

    this.evaluationService.getObserveEvaluationSeries(this.userID, "observeComments").subscribe((seriesData: any) => {
      if (!seriesData || seriesData.selectedSeries == null) {
        this.layoutService.showLoader = false;
        return;
      }

      this.selectedSeries = JSON.parse(seriesData.selectedSeries);
      if (this.selectedSeries.length == 0) {
        this.layoutService.showLoader = false;
        return;
      }

      let chartSeries = JSON.parse(seriesData.selectedSeries);

      this.selectedSeries.forEach((serie) => {
        for (let i = 0; i < this.charts.length; i++) {
          if (i == serie.resultIndex) {
            this.charts.toArray()[i].internalToggleSerie({ index: serie.serieIndex });
          }
        }
      });

      setTimeout(() => {
        chartSeries.forEach(serie => {
          if(typeof serie === 'number'){
              this.charts.forEach((chart) => {
                this.compliance.toggleVisibility(chart.chartId, {index: serie });
                chart.internalToggleSerie({ index: serie });
              });
          }else{
            let chart = this.charts.find(c => c.chartId === serie.chartId);
            if(!chart) return;
            serie.series.forEach((serie) => {
              chart.internalToggleSerie({ index: serie });
              this.compliance.toggleVisibility(chart.chartId, {index: serie });
            });
            this.filters.forEach((filter, index) => {
              if (index != serie.series) return;
              if (filter.visible == undefined) filter.visible = true;
              filter.visible = !filter.visible;
            });
          }
        });
      }, 1500);
    }, (error) => {
      this.layoutService.showLoader = false;
    }, () => {
      this.layoutService.showLoader = false;
    });
  }

  filterBenchmarkDataIfWardIsSelected(res): any {
    if (this.shouldHideBenchmarkData())
      return res.filter(item => !item.isBenchmark);
    else
      return res;
  }

  shouldHideBenchmarkData() {
    return this.anyWardIsSelected();
  }

  anyWardIsSelected() {
    for (let filterComponent of this.filters.toArray()) {
      if (filterComponent.isWardSelected()) {
        return true;
      }
    }
    return false;
  }

  adjustResponseForEnvironment(res) {
    if (!this.isDesktop && res.length >= 2) {
      let spliceCount = 0;
      let idx = 1;
      res.forEach((processComplianceArray: any, index) => {
        if (index === 1) {
          if (processComplianceArray.isBenchmark === false) {
            spliceCount++;
          } else {
            idx = 2;
          }
        } else if (index === 2 || index === 3) {
          spliceCount++;
        }
      });
      return res.splice(idx, spliceCount);
    }
    return res;
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }

  getPredefinedComments() {
    var roleId = this.appConfig.userData.roleName.roleId

    if (roleId == 1) {
      this.evaluationService.getPredefinedComments().subscribe((res) => {
        this.quickComments = res.filter((comment) => !comment.isDeleted);
        this.selectedCommentName = this.layoutService.translateText('EVALUATION.All.COMMENTS');
      });
    } else {
      this.evaluationService.getPredefinedCommentsListForObservation(this.appConfig.userData.country, this.appConfig.institutions || 0).subscribe((res) => {
        this.quickComments = [];
        for (let i = 0; i < res.length; i++) {
          if (res[i].predefinedCommentID == 1) { res[i].commentName = 'SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH'; }
          if (res[i].predefinedCommentID == 2) { res[i].commentName = 'SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH'; }
          if (res[i].predefinedCommentID == 3) { res[i].commentName = 'SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED'; }
          if (res[i].predefinedCommentID == 4) { res[i].commentName = 'SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED'; }
          if (res[i].predefinedCommentID == 5) { res[i].commentName = 'SOP_OBSERVATION.PROCESS_INTERRUPTED'; }
        }

        this.quickComments = res.filter((comment) => !comment.isDeleted);
        this.selectedCommentName = this.layoutService.translateText('EVALUATION.All.COMMENTS');
      });
    }
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  resetFilters() {
    this.onCommentChange(0, false);
    this.filterDetails = [this.filterDetails[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter(true);
    this.layoutService.showLoader = true;
    var seriesData = {
      userId: this.userID,
      complianceType: "observeComments",
      selectedSeries: null
    };

    this.evaluationService.updateObserveEvaluationSeries(seriesData).subscribe(() => { 
      setTimeout(() => { this.evaluate(true); }, 1500);
    }, () => { }, () => { });

  }

  originalFields: any[] = null;
  originalBenchmarkFields: any[] = null;
  selectedSeries: any[] = [];

  onSeriesClick(serie: any, resultIndex: number) {
    let chart = this.charts.find( c => c.chartId == serie.chartId);
    chart.series.get(serie.index).options.visible = serie.visible;

    this.filters.forEach((filter, index) => {
      if (index != serie.index) return;
      if (filter.visible == undefined) filter.visible = true;
      filter.visible = !filter.visible;
    });

    this.compliance.toggleVisibility(serie.chartId,serie);

    let visibilitySeries = [];

    this.charts.forEach((chart) => {
      let c = {
        chartId: chart.chartId,
        series: chart.series.map((s, index) => ({ series: s, index }))
                            .filter(s => s.series.options.visible === false)
                            .map(s => s.index)
      }
      visibilitySeries.push(c);
    })

    var seriesData = {
      userId: this.userID,
      complianceType: "observeComments",
      selectedSeries: JSON.stringify(visibilitySeries)
    };

    this.evaluationService.updateObserveEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
  }

  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

    if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  trackLoop(index: number, item: any) {
    return item;
  }
}
